import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ChevronUpIcon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
function TrustBlock({
  open,
  onToggle
}: {
  open: boolean;
  onToggle: () => void;
}) {
  return <div className="mt-6 space-y-4" data-id="element-339">
      {/* Garantía accordion */}
      <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-340">
        <button onClick={onToggle} className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50 transition-colors" data-id="element-341">
          <span className="flex items-center gap-2 font-bold text-gray-900" data-id="element-342">
            <span className="text-lg" data-id="element-343">🏆</span>
            Garantía de satisfacción 7 días
          </span>
          {open ? <ChevronUpIcon className="w-5 h-5 text-gray-500" data-id="element-344" /> : <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-345" />}
        </button>
        {open && <div className="px-5 pb-5 text-left text-sm text-gray-600 leading-relaxed" data-id="element-346">
            <p className="mb-3" data-id="element-347">
              Si aplicás el contenido y sentís que no te aporta claridad o no es
              para vos, podés{' '}
              <strong className="text-gray-900" data-id="element-348">
                solicitar una devolución dentro de los primeros 7 días.
              </strong>
            </p>
            <p data-id="element-349">Quiero que compres segura/o, no con dudas.</p>
          </div>}
      </div>

      {/* Pago seguro garantizado */}
      <fieldset className="border border-gray-200 rounded-xl px-5 py-4" data-id="element-350">
        <legend className="flex items-center gap-2 px-2 text-sm font-semibold text-gray-600" data-id="element-351">
          <ShieldCheckIcon className="w-4 h-4 text-brand-green" data-id="element-352" />
          Pago seguro garantizado
        </legend>
        <img src="https://cdn.magicpatterns.com/uploads/hzgvUoMWhjNHxhRDn2LPwT/Imagen_28-3-26_a_las_5.16_p._m._(1).jpg" alt="Métodos de pago: Mercado Pago, Visa, Mastercard, Cabal, American Express, Tarjeta Shopping, Cencosud, Argencard, Provincia NET, Link, Banelco, Pago Fácil, Rapipago, Naranja" className="w-full max-w-sm mx-auto" data-id="element-353" />
      </fieldset>
    </div>;
}
export function PricingSection() {
  const [guaranteeOpen1, setGuaranteeOpen1] = useState(false);
  const [guaranteeOpen2, setGuaranteeOpen2] = useState(false);
  return <section id="pricing" className="w-full bg-brand-bg pt-6 md:pt-8 pb-8 md:pb-10 px-6" data-id="element-354">
      <div className="max-w-7xl mx-auto" data-id="element-355">
        <motion.div className="flex flex-col lg:flex-row gap-8 items-start" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-356">
          {/* Product image */}
          <div className="w-full lg:w-[58%] flex-shrink-0 flex items-start justify-center" data-id="element-357">
            <img src="https://cdn.magicpatterns.com/uploads/omYywJrgfxauw9XP56Yh5q/Imagen_29-3-26_a_las_12.04_a._m..jpg" alt="Emprende Digital: Guía Paso a Paso — Tienda, diseño, automatización y ventas, todo en una sola guía" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-358" />
          </div>

          {/* Pricing card */}
          <div className="w-full lg:w-[42%] bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-lg shadow-brand-green/5" data-id="element-359">
            {/* Banner */}
            <div className="bg-brand-green py-3 text-center" data-id="element-360">
              <span className="text-white text-sm font-bold uppercase tracking-widest" data-id="element-361">
                Promoción por tiempo limitado
              </span>
            </div>

            <div className="px-8 py-10 text-center" data-id="element-362">
              {/* Guía Completa Paso a Paso */}
              <p className="text-lg font-bold text-gray-900 mb-2" data-id="element-363">
                Guía Completa Paso a Paso
              </p>
              <p className="text-sm text-gray-600 mb-6" data-id="element-364">
                Acceso a la guía completa paso a paso + Llamada grupal donde
                respondemos todas tus dudas + Comunidad de WhatsApp
              </p>

              <div className="mb-6" data-id="element-365">
                <p className="text-xl text-gray-400 line-through mb-2" data-id="element-366">
                  $60.000 ARS
                </p>
                <p className="flex items-baseline justify-center gap-1" data-id="element-367">
                  <span className="text-lg text-gray-400" data-id="element-368">$</span>
                  <span className="text-5xl md:text-6xl font-bold text-gray-900" data-id="element-369">
                    19.900
                  </span>
                  <span className="text-lg text-gray-500 ml-1" data-id="element-370">ARS</span>
                </p>
                <p className="text-sm font-semibold text-brand-green mt-4" data-id="element-371">
                  Precio lanzamiento por tiempo limitado
                </p>
              </div>

              <a href="https://www.emprende-digital.com/cart/51742249156888:1" target="_blank" rel="noopener noreferrer" className="block w-full max-w-xs mx-auto bg-brand-green hover:bg-brand-green-hover text-white font-bold text-lg py-4 rounded-xl transition-colors duration-200 shadow-lg shadow-brand-green/20 text-center mb-4" data-id="element-372">
                🔥 Acceder Ahora
              </a>

              <p className="text-sm text-gray-600 mb-2" data-id="element-373">
                🎁 + de regalo 3 bonos valorados en un total de $67.000
                totalmente{' '}
                <strong className="text-brand-green" data-id="element-374">¡GRATIS!</strong>
              </p>
              <p className="text-sm text-gray-600 mb-2" data-id="element-375">
                🎓 + 2 clases incluidas:{' '}
                <strong className="text-gray-900" data-id="element-376">
                  Clase completa de campañas de venta en Meta Ads
                </strong>{' '}
                ($70.000) y{' '}
                <strong className="text-gray-900" data-id="element-377">
                  Taller grabado: Meta Ads + Shopify
                </strong>{' '}
                ($50.000) totalmente{' '}
                <strong className="text-brand-green" data-id="element-378">¡GRATIS!</strong>
              </p>
              <p className="text-sm text-gray-500 mt-2" data-id="element-379">
                📩 Acceso inmediato al eBook después del pago, se envía a tu
                correo electrónico
              </p>

              {/* Trust block for Guía Completa */}
              <TrustBlock open={guaranteeOpen1} onToggle={() => setGuaranteeOpen1(!guaranteeOpen1)} data-id="element-380" />
            </div>
          </div>
        </motion.div>

        {/* Tienda Líder Platinum badge */}
        <motion.div className="mt-8 flex justify-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-381">
          <img src="https://cdn.magicpatterns.com/uploads/6a1pUYDihJzNUtN2uLf8oo/Imagen_29-3-26_a_las_12.25_a._m..jpg" alt="Tienda Líder Platinum — 3758 ventas en los últimos 60 días, brinda un buen servicio, entrega los productos a tiempo" className="w-full max-w-sm h-auto rounded-2xl shadow-md" data-id="element-382" />
        </motion.div>

        {/* Nivel 2 Avanzado title */}
        <motion.div className="mt-16 md:mt-20 text-center" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-383">
          <h2 className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-bold text-black leading-[1.25] flex flex-col items-center gap-1" data-id="element-384">
            <span className="whitespace-nowrap" data-id="element-385">
              <span className="text-[#1fa855] relative" data-id="element-386">
                Membresía y Comunidad
                <span className="absolute -bottom-1 left-0 w-full h-[3px] bg-gray-200 rounded-full" data-id="element-387" />
              </span>
            </span>
            <span className="whitespace-nowrap" data-id="element-388">
              Para quienes ya están en el proceso
            </span>
            <span className="whitespace-nowrap" data-id="element-389">
              y quieren avanzar al siguiente nivel{' '}
              <span className="text-[#1fa855] relative" data-id="element-390">
                MÁS RÁPIDO
                <span className="absolute -bottom-1 left-0 w-full h-[3px] bg-gray-200 rounded-full" data-id="element-391" />
              </span>
            </span>
          </h2>
        </motion.div>

        {/* Membresía card - separate centered block */}
        <motion.div className="mt-8 max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut',
        delay: 0.15
      }} data-id="element-392">
          <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden shadow-lg shadow-brand-green/5" data-id="element-393">
            <div className="bg-gray-900 py-3 text-center" data-id="element-394">
              <span className="text-white text-sm font-bold uppercase tracking-widest" data-id="element-395">
                Membresía
              </span>
            </div>

            <div className="px-8 py-8" data-id="element-396">
              <div className="flex flex-col md:flex-row gap-8" data-id="element-397">
                {/* Left: features */}
                <div className="flex-1 text-left" data-id="element-398">
                  <ul className="space-y-3 text-sm text-gray-600" data-id="element-399">
                    <li className="flex items-start gap-2" data-id="element-400">
                      <span data-id="element-401">👉🏻</span>
                      <span data-id="element-402">
                        <strong className="text-gray-900" data-id="element-403">
                          Formación Iniciación
                        </strong>{' '}
                        desbloquea tu potencial{' '}
                        <span className="text-brand-green font-semibold" data-id="element-404">
                          (Valorado en 500 USD)
                        </span>
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-405">
                      <span data-id="element-406">👉🏻</span>
                      <span data-id="element-407">
                        <strong className="text-gray-900" data-id="element-408">
                          Mentorías semanales EN VIVO con SOLE
                        </strong>{' '}
                        <span className="text-brand-green font-semibold" data-id="element-409">
                          (Valor incalculable)
                        </span>
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-410">
                      <span data-id="element-411">👉🏻</span>
                      <span data-id="element-412">
                        <strong className="text-gray-900" data-id="element-413">
                          Mentorías en vivo grabadas
                        </strong>{' '}
                        <span className="text-brand-green font-semibold" data-id="element-414">
                          (Valorado en 700 USD)
                        </span>
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-415">
                      <span data-id="element-416">👉🏻</span>
                      <span data-id="element-417">
                        <strong className="text-gray-900" data-id="element-418">
                          BONUS: FORMACIÓN EN EDICIÓN DE VIDEO Y MARKETING DE
                          AFILIADOS
                        </strong>{' '}
                        🎁{' '}
                        <span className="text-brand-green font-semibold" data-id="element-419">
                          (Valorado en 1000 USD)
                        </span>
                      </span>
                    </li>
                  </ul>
                </div>

                {/* Right: pricing + CTA */}
                <div className="flex-1 text-center flex flex-col items-center justify-center" data-id="element-420">
                  <div className="mb-5" data-id="element-421">
                    <p className="flex items-baseline justify-center gap-1" data-id="element-422">
                      <span className="text-lg text-gray-400" data-id="element-423">$</span>
                      <span className="text-5xl md:text-6xl font-bold text-gray-900" data-id="element-424">
                        100
                      </span>
                      <span className="text-lg text-gray-500 ml-1" data-id="element-425">
                        USD/mes
                      </span>
                    </p>
                    <p className="text-sm font-semibold text-brand-green mt-3" data-id="element-426">
                      Precio lanzamiento por tiempo limitado
                    </p>
                  </div>

                  <a href="https://www.emprende-digital.com/cart/51868533883160:1" target="_blank" rel="noopener noreferrer" className="block w-full max-w-xs bg-gray-900 hover:bg-gray-800 text-white font-bold text-lg py-4 rounded-xl transition-colors duration-200 shadow-lg text-center mb-4" data-id="element-427">
                    🚀 Membresía
                  </a>

                  <p className="text-sm text-gray-500 mb-1" data-id="element-428">
                    Actualizaciones incluidas +{' '}
                    <strong className="text-gray-700" data-id="element-429">
                      toda la información
                    </strong>
                  </p>
                  <p className="text-sm text-gray-400 mb-2" data-id="element-430">
                    Pago 100% seguro • Mercado Pago
                  </p>
                  <p className="text-sm text-gray-500" data-id="element-431">📩 Acceso inmediato</p>
                </div>
              </div>

              <TrustBlock open={guaranteeOpen2} onToggle={() => setGuaranteeOpen2(!guaranteeOpen2)} data-id="element-432" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}